import { Flex, Heading, Text } from "@radix-ui/themes";
import { WidgetRootDomProps } from "./utils.js";

interface EmptyStateProps extends WidgetRootDomProps {
  heading: string;
  message: string;
  action?: React.ReactNode;
}

export function EmptyState({
  heading,
  message,
  action,
  ...domProps
}: EmptyStateProps) {
  return (
    <Flex
      p="6"
      gap="4"
      justify="center"
      align="center"
      direction="column"
      {...domProps}
    >
      <Flex direction="column" gap="1" maxWidth="420px">
        <Heading size="5" align="center" mb="1" wrap="balance" as="h3">
          {heading}
        </Heading>

        <Text as="p" align="center" wrap="balance" color="gray">
          {message}
        </Text>
      </Flex>

      {action}
    </Flex>
  );
}
